import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  GoogleConfigInterface,
  GoogleItemTypeInterface,
  ShareToProvider,
  ShareToService,
  SHARE_TO_CLASSROOM_ID,
} from '../../services';

@Component({
  standalone: false,
  selector: 'campus-share-to',
  styleUrls: ['./share-to.component.scss'],
  templateUrl: './share-to.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareToComponent implements OnChanges {
  @HostBinding('class.share-to') hasShareToClass = true;

  @Input() provider: ShareToProvider;

  @Input() body: string;
  @Input() title: string;
  @Input() url: string;
  @Input() type: GoogleItemTypeInterface;

  shareToClassroomId = SHARE_TO_CLASSROOM_ID;

  constructor(private shareToService: ShareToService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.shareToService.clear(this.provider);
    let config;
    if (this.provider === 'google') {
      config = {
        size: 24,
        url: this.url,
        title: this.title,
        body: this.body || '',
        itemtype: this.type,
      } as GoogleConfigInterface;
    }
    this.shareToService.renderSocialShareButton(this.provider, config);
  }
}
